import { useTranslation } from 'next-i18next/pages'

import { PageTitle } from 'components/PageTitle'
import type { PageMeta } from 'types/page-meta'

type Props = {
  pageMeta?: PageMeta
}

export const AppPageTitle = ({ pageMeta }: Props) => {
  const { t } = useTranslation()

  return (
    <PageTitle
      title={
        pageMeta?.titleTranslationKey
          ? t(pageMeta.titleTranslationKey)
          : undefined
      }
      description={
        pageMeta?.descriptionTranslationKey
          ? t(pageMeta.descriptionTranslationKey)
          : undefined
      }
      metaData={pageMeta?.metaData}
      canonical={pageMeta?.canonical}
      noIndex={pageMeta?.noIndex}
    />
  )
}
